import { postDataFlexibleTyped, buildUrl } from "../apiService"

const apiRoutes = {
  post: {
    ADVANCED_SEARCH_ROUTE: "/search/advancedSearch",
    TYPEAHEAD_SEARCH_ROUTE: "/search/typeahead",
  },
}

const postAdvancedSearch = async (searchBodyOptions: unknown) => {
  return postDataFlexibleTyped<unknown[], unknown>(
    buildUrl(apiRoutes.post.ADVANCED_SEARCH_ROUTE),
    searchBodyOptions,
  )
}

const postTypeaheadSearch = async (searchBodyOptions: unknown) => {
  return postDataFlexibleTyped<any[], unknown>(
    buildUrl(apiRoutes.post.TYPEAHEAD_SEARCH_ROUTE),
    searchBodyOptions,
  )
}

export const searchApi = {
  post: {
    ADVANCED_SEARCH: postAdvancedSearch,
    TYPEAHEAD_SEARCH: postTypeaheadSearch,
  },
}
